"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECOND_STAGE_WIDTH = exports.FIRST_STAGE_WIDTH_MOBILE = exports.FIRST_STAGE_WIDTH = exports.BASE_STAGE_COLOR = void 0;
var BASE_STAGE_COLOR = exports.BASE_STAGE_COLOR = {
  r: 241,
  g: 247,
  b: 210
};
var FIRST_STAGE_WIDTH_MOBILE = exports.FIRST_STAGE_WIDTH_MOBILE = 126;
var FIRST_STAGE_WIDTH = exports.FIRST_STAGE_WIDTH = 178;
var SECOND_STAGE_WIDTH = exports.SECOND_STAGE_WIDTH = 72;